import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useId } from "react";
import styles from "./StateSwitch.module.css";
/**
 * Alternância de estado reversível do Azim CRM (StateSwitch).
 * Desenha o próprio controle (trilho de 22px dentro de um alvo de 32px) em vez
 * de compor o `Toggle` do pacote — ver DD-002 do design de platform-config-ux.
 * Exibe rótulo textual do estado atual e, quando travado, o motivo.
 */
export function StateSwitch({ checked, onChange, label, onLabel, offLabel, lockedReason, busy = false, }) {
    const reasonId = useId();
    const locked = Boolean(lockedReason);
    const disabled = locked || busy;
    const handleClick = () => {
        if (disabled)
            return;
        onChange(!checked);
    };
    return (_jsxs("div", { className: styles.root, children: [_jsx("button", { type: "button", role: "switch", "aria-checked": checked, "aria-label": label, "aria-describedby": locked ? reasonId : undefined, "aria-busy": busy || undefined, disabled: disabled, onClick: handleClick, className: [styles.control, locked ? styles.locked : ""].filter(Boolean).join(" "), children: _jsx("span", { className: styles.rail, "data-checked": checked, children: _jsx("span", { className: styles.thumb }) }) }), _jsxs("div", { className: styles.text, children: [_jsx("span", { className: styles.stateLabel, children: checked ? onLabel : offLabel }), locked && (_jsx("span", { id: reasonId, className: styles.lockedReason, children: lockedReason }))] })] }));
}
//# sourceMappingURL=StateSwitch.js.map